import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_FILTERS, type OpportunitiesFilters } from '../types/opportunity.types';

interface OpportunitiesState {
  filters: OpportunitiesFilters;
  setFilters: (patch: Partial<OpportunitiesFilters>) => void;
  resetFilters: () => void;
}

export const useOpportunitiesStore = create<OpportunitiesState>()(
  persist(
    (set) => ({
      filters: DEFAULT_FILTERS,
      setFilters: (patch) =>
        set((s) => {
          // Cualquier cambio de filtro vuelve a página 1 EXCEPTO si el patch
          // sólo cambia `page` o `sortBy`.
          const isPageOrSortOnly =
            ('page' in patch || 'sortBy' in patch) &&
            Object.keys(patch).every((k) => k === 'page' || k === 'sortBy');
          return {
            filters: {
              ...s.filters,
              ...patch,
              page: isPageOrSortOnly ? (patch.page ?? s.filters.page) : 1,
            },
          };
        }),
      resetFilters: () => set({ filters: DEFAULT_FILTERS }),
    }),
    { name: 'opportunities-filters' }
  )
);
